"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppAdminSelfUpdate = void 0;
const typebox_1 = require("@sinclair/typebox");
const authority_transport_1 = require("./authority-transport");
exports.AppAdminSelfUpdate = typebox_1.Type.Intersect([
    typebox_1.Type.Object({
        application: authority_transport_1.Applications,
    }),
    typebox_1.Type.Union([
        typebox_1.Type.Object({
            application: typebox_1.Type.Literal('wayste'),
            haulerID: typebox_1.Type.String({
                format: 'uuid',
            }),
        }),
        typebox_1.Type.Object({
            application: typebox_1.Type.Literal('customer-portal'),
            customer: typebox_1.Type.Object({
                customerID: typebox_1.Type.String({ format: 'uuid' }),
                contactID: typebox_1.Type.String({ format: 'uuid' }),
            }),
        }),
    ]),
]);
//# sourceMappingURL=app-admin.js.map